import { useEffect, useState } from 'react';
import type { SearchChipItem } from '../types';
import { useInputValue } from './useInputValue';

type UseSearchBarProps = {
  searchChip?: SearchChipItem;
  scrollToFilterList: VoidFunction;
};

export const useSearchBar = ({
  searchChip,
  scrollToFilterList,
}: UseSearchBarProps) => {
  const [isSearchBarOpen, setIsSearchBarOpen] = useState(false);
  const { inputValue, setInputValue } = useInputValue({
    initialValue: searchChip?.query_value,
  });

  useEffect(() => {
    const isOpen = searchChip?.is_selected ?? false;
    setIsSearchBarOpen(isOpen);
  }, [searchChip]);

  const toggleSearchBar = () => {
    if (!isSearchBarOpen) {
      setTimeout(() => {
        scrollToFilterList();
      }, 10);
    }
    setIsSearchBarOpen(prev => !prev);
  };

  const closeFilterList = () => {
    setIsSearchBarOpen(false);
  };
  return {
    isSearchBarOpen,
    toggleSearchBar,
    inputValue,
    setInputValue,
    closeFilterList,
  };
};
